/**
 * Created by jacmai on 6/26/2017.
 */
define([
  "marionette",
  "messaging/messenger",
  "./variablePromptsListView",
  "modules/shared/sortableList/sortableListModule",
  "./variablePromptsListModel",
], function (
  Marionette,
  Messenger,
  VariablePromptsListView,
  SortableListModule,
  VariablePromptsListModel,
) {
  var VariablePromptsListController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "variablePromptsList";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (conversationVariables) {
      var headers = Messenger.reqres.request("variable:prompts:headers");
      this.layout = new VariablePromptsListView.variablePromptsList();
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: this.name,
        }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(conversationVariables);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function (conversationVariables) {
      this.list.show(conversationVariables);
    },
    _setUpVents: function () {
      //selected a variable prompt from the sortable list
      Messenger.vent.on(
        "variablePromptsList:selected:row",
        function (model) {
          //trigger event to show the variable prompt
          Messenger.vent.trigger("show:variable:prompt", model);
        },
        this,
      );
    },
  });

  return VariablePromptsListController;
});
